import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import ProjectSelectModal from '../components/ProjectSelectModal';

const ProjectsQuery = gql`
  query allProjects {
    allProjects {
      _id
      key
      name
    }
  }
`;

export default graphql(ProjectsQuery)(ProjectSelectModal);



// WEBPACK FOOTER //
// ./src/containers/ProjectSelector.js